// import React from "react";
// import { IconButton, Typography } from "@mui/material";
// import AccountCircleIcon from "@mui/icons-material/AccountCircle";

// const ProfileIcon = ({ onClick, firstName, image }) => {
//   console.log("firstName", firstName);

//   return (
//     <IconButton color="inherit" onClick={onClick}>
//       {image ? (
//         <img
//           src={image}
//           alt="Profile"
//           style={{
//             borderRadius: "50%",
//             width: "40px",
//             height: "40px",
//             objectFit: "cover",
//           }}
//         />
//       ) : firstName ? (
//         <Typography
//           sx={{
//             backgroundColor: "#3f51b5",
//             color: "white",
//             borderRadius: "50%",
//             width: "40px",
//             height: "40px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             fontSize: "1.5rem",
//           }}
//         >
//           {firstName[0].toUpperCase()}
//         </Typography>
//       ) : (
//         <AccountCircleIcon sx={{ fontSize: "2.5rem" }} />
//       )}
//     </IconButton>
//   );
// };

// export default ProfileIcon;

import React, { useState } from "react";
import { IconButton, Typography } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const ProfileIcon = ({ onClick, firstName, image }) => {
  const [imgError, setImgError] = useState(false);

  return (
    <IconButton color="inherit" onClick={onClick}>
      {!imgError && image ? (
        <img
          src={image}
          alt="Profile"
          onError={() => setImgError(true)} // Handle broken image
          style={{
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            objectFit: "cover",
          }}
        />
      ) : firstName ? (
        <Typography
          sx={{
            backgroundColor: "#3f51b5",
            color: "white",
            borderRadius: "50%",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.5rem",
          }}
        >
          {firstName[0].toUpperCase()}
        </Typography>
      ) : (
        <AccountCircleIcon sx={{ fontSize: "2.5rem" }} />
      )}
    </IconButton>
  );
};

export default ProfileIcon;
